import { runStaticQuery } from 'src/api/query/run.staticQuery';
import { run as runActions } from '../../../../store/workspaces/workspaces/run';
import { runWorkflow } from 'src/api/workflow/runWorkflow';
import { clearBreadcrumb } from 'src/store/workspaces/breadcrumb/actions';
import store from 'src/store/store';
import { setNavigationTreeData } from 'src/store/workspaces/navigation/actions';
import { TabService } from 'src/api/services/workspaces/Service.tab';
import { WorkspaceService } from 'src/api/services/workspaces/Service.workspace';

export const goHome = async () => {
  const response = await runStaticQuery('workspace', null);
  const onLoadEvent = response.workspace.events.find((event) => event?.type === 'onLoad');
  const { instances } = store.getState().workspaces;

  if (onLoadEvent) {
    const key = onLoadEvent.key;
    const response = await runWorkflow(key, null, {}, null, true);
    await runActions(key, null, { ...response });
    await store.dispatch(clearBreadcrumb());
    await store.dispatch(setNavigationTreeData([]));
  }

  const currentGroup = JSON.parse(localStorage.getItem('activeWorkspace') || '{}');

  const tabService = new TabService();
  const workspace = store.getState().workspaces.instances[instances.length];
  await tabService.setTab(workspace, null);

  const currentTab = instances.at(0);
  currentGroup.tabs = [...(currentGroup.tabs || []), currentTab.uuid];

  const workspaceService = new WorkspaceService();
  await workspaceService.update(currentGroup);
};
